import React from "react";
import { classnames, Icon } from "@culturehq/components";
import { isSynopsys } from "app/utils";
import ExclamationIcon from "components/common/ExclamationIcon";
import DisclaimerText from "./DisclaimerText";

interface StoryDisclaimerProps {
  organizationName: string;
}

const StoryDisclaimer: React.FC<StoryDisclaimerProps> = ({ organizationName }) => (
  <div className={classnames("DisclaimerContainer", `DisclaimerContainer-${organizationName.replace(/\s+/g, "-")?.toLowerCase()}`)}>
    <p>
      {isSynopsys(organizationName) ? (
        <Icon className="DisclaimerContainer-Text--Icon" icon="asterisk" />
      ) : (
        <ExclamationIcon className="DisclaimerContainer-Text--Icon" />
      )}
    </p>
    <p className="DisclaimerContainer-Text">
      <DisclaimerText organizationName={organizationName} />
    </p>
  </div>
);

export default StoryDisclaimer;
